import type { SowType } from '@clockwise/clients/sows';
import { cn } from '@/lib/utils';

const LABELS: Record<SowType, string> = {
  retainer: 'Retainer',
  tm: 'T&M',
  metrics: 'Metrics',
  hybrid: 'Hybrid',
};

const STYLES: Record<SowType, string> = {
  retainer: 'bg-emerald-100 text-emerald-900 dark:bg-emerald-900/30 dark:text-emerald-200',
  tm: 'bg-blue-100 text-blue-900 dark:bg-blue-900/30 dark:text-blue-200',
  metrics: 'bg-amber-100 text-amber-900 dark:bg-amber-900/30 dark:text-amber-200',
  // Any mix of models, so it gets its own colour rather than one of theirs.
  hybrid: 'bg-violet-100 text-violet-900 dark:bg-violet-900/30 dark:text-violet-200',
};

export function SowTypeBadge({
  type,
  className,
}: {
  type: SowType | null | undefined;
  className?: string;
}) {
  if (!type) return null;
  return (
    <span className={cn('rounded-full px-2 py-0.5 text-xs font-medium', STYLES[type], className)}>
      {LABELS[type]}
    </span>
  );
}
